/**
 * The Microsoft Graph delegated permissions OneTaskList's own multi-tenant Entra app registration
 * asks for when a user connects Microsoft 365 Copilot.
 *
 * One list, shared by the sign-in call and the consent summary the connect form shows, because it
 * describes a single registration we own. It is not configurable per deployment: changing it here
 * without changing the registration would only produce a consent prompt Entra rejects.
 */
export const m365CopilotScopes: string[] = [
  "Sites.Read.All",
  "Mail.Read",
  "People.Read.All",
  "OnlineMeetingTranscript.Read.All",
  "Chat.Read",
  "ChannelMessage.Read.All",
  "ExternalItem.Read.All",
];
